import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  TextField,
  Checkbox,
} from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import { ErrorMessage } from 'components';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {
  INDIVIDUAL_OR_CORPORATE,
  PLUS_MINUS,
  PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE,
  PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE_TEXT,
  PERIOD_UNIT,
  AFTER_CURRENT_PURPOSE,
  APPLICABLE_CHECK,
  LINE_MESSAGE_TEMPLATE,
  LINE_MESSAGE_TYPE,
  GENDER,
  DRIVER_LICENSE_COLOR,
  DRIVER_AGE_CONDITION,
  DRIVER_LIMITED_CONDITION,
} from 'const';

import PriceCommaTextField from 'utils/PriceCommaTextField';
import { isPermitted } from 'utils/utils';

import { currentUserSelector } from "store/current_user"

const useStyles = makeStyles(() => ({
  root: {},
}));

const ChatInputEdit = (props) => {
  const { className, detailData, chatInputFormik } = props;
  const classes = useStyles();
  const chatInput = detailData.chatInput;
  const currentUser = useSelector(currentUserSelector)

  return (
    <>
      <Card>
        <CardHeader title='共通（基本情報）' className={styles.lineChatColor} />
        <CardContent className={styles.cardContent}>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>
                  チャット種別<span className={styles.required}>必須</span>
                </p>
                <Select
                  fullWidth
                  className={styles.selecter}
                  {...chatInputFormik.getFieldProps('messageType')}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(event) => {
                    chatInputFormik.setFieldValue(
                      'messageType',
                      event.target.value || null
                    );
                    chatInputFormik.setFieldValue(
                      'message',
                      LINE_MESSAGE_TEMPLATE[event.target.value]
                    );
                  }}
                  value={chatInputFormik.values.messageType || 0}
                  error={
                    !!(
                      chatInputFormik.touched.messageType &&
                      chatInputFormik.errors.messageType
                    )
                  }
                >
                  <MenuItem value={0}>&nbsp;</MenuItem>
                  <MenuItem value={1}>{LINE_MESSAGE_TYPE[1]}</MenuItem>
                  <MenuItem value={2}>{LINE_MESSAGE_TYPE[2]}</MenuItem>
                  <MenuItem value={3}>{LINE_MESSAGE_TYPE[3]}</MenuItem>
                </Select>
                <ErrorMessage
                  touched={chatInputFormik.touched.messageType}
                  error={chatInputFormik.errors.messageType}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className={styles.item}>
                <p className={styles.labelTop}>送信メッセージ</p>
                <TextField
                  fullWidth
                  type='text'
                  variant='outlined'
                  {...chatInputFormik.getFieldProps('message')}
                  value={chatInputFormik.values.message || ''}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(event) => {
                    chatInputFormik.setFieldValue(
                      'message',
                      event.target.value
                    );
                  }}
                  error={
                    !!(
                      chatInputFormik.touched.message &&
                      chatInputFormik.errors.message
                    )
                  }
                />
                <ErrorMessage
                  touched={chatInputFormik.touched.message}
                  error={chatInputFormik.errors.message}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>
                  現在の契約自動車車名
                  <span className={styles.required}>必須</span>
                </p>
                <TextField
                  fullWidth
                  type='text'
                  variant='outlined'
                  {...chatInputFormik.getFieldProps('currentContractCarName')}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(event) =>
                    chatInputFormik.setFieldValue(
                      'currentContractCarName',
                      event.target.value
                    )
                  }
                  value={chatInputFormik.values.currentContractCarName || ''}
                  error={
                    !!(
                      chatInputFormik.touched.currentContractCarName &&
                      chatInputFormik.errors.currentContractCarName
                    )
                  }
                />
                <ErrorMessage
                  touched={chatInputFormik.touched.currentContractCarName}
                  error={chatInputFormik.errors.currentContractCarName}
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>
                  現在の契約自動車 登録番号下４桁
                  <span className={styles.required}>必須</span>
                </p>
                <TextField
                  fullWidth
                  type='text'
                  variant='outlined'
                  {...chatInputFormik.getFieldProps(
                    'currentContractCarRegistrationNumber'
                  )}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(event) => {
                    if (4 < event.target.value.length) {
                      return;
                    }
                    chatInputFormik.setFieldValue(
                      'currentContractCarRegistrationNumber',
                      event.target.value
                    );
                  }}
                  value={chatInputFormik.values.currentContractCarRegistrationNumber || ''}
                  error={
                    !!(
                      chatInputFormik.touched
                        .currentContractCarRegistrationNumber &&
                      chatInputFormik.errors
                        .currentContractCarRegistrationNumber
                    )
                  }
                />
                <ErrorMessage
                  touched={
                    chatInputFormik.touched.currentContractCarRegistrationNumber
                  }
                  error={
                    chatInputFormik.errors.currentContractCarRegistrationNumber
                  }
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <span className={styles.labelTop}>長期契約フラグ</span>
                <Checkbox
                  checked={chatInputFormik.values.isLongTermContract === 1}
                  color='primary'
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onClick={() =>
                    chatInputFormik.setFieldValue(
                      'isLongTermContract',
                      chatInputFormik.values.isLongTermContract === 1
                        ? 2
                        : 1
                    )
                  }
                />
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {detailData.vehicle?.id && (
        <Card className={clsx(classes.root, className)}>
          <CardHeader title='車両入替' className={styles.lineChatColor} />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={7}>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        変更後の契約自動車車名
                        <span className={styles.required}>必須</span>
                      </p>
                      <TextField
                        fullWidth
                        type='text'
                        variant='outlined'
                        {...chatInputFormik.getFieldProps(
                          'updatedContractCarName'
                        )}
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(event) =>
                          chatInputFormik.setFieldValue(
                            'updatedContractCarName',
                            event.target.value
                          )
                        }
                        value={chatInputFormik.values.updatedContractCarName || ''}
                        error={
                          !!(
                            chatInputFormik.touched.updatedContractCarName &&
                            chatInputFormik.errors.updatedContractCarName
                          )
                        }
                      />
                      <ErrorMessage
                        touched={chatInputFormik.touched.updatedContractCarName}
                        error={chatInputFormik.errors.updatedContractCarName}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        初度登録年月
                        <span className={styles.required}>必須</span>
                      </p>
                      <TextField
                        fullWidth
                        type='text'
                        variant='outlined'
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(event) =>
                          chatInputFormik.setFieldValue(
                            'yearAndMonthOfFirstRegistration',
                            event.target.value
                          )
                        }
                        {...chatInputFormik.getFieldProps(
                          'yearAndMonthOfFirstRegistration'
                        )}
                        value={
                          chatInputFormik.values
                            .yearAndMonthOfFirstRegistration || ''
                        }
                        error={
                          !!(
                            chatInputFormik.touched
                              .yearAndMonthOfFirstRegistration &&
                            chatInputFormik.errors
                              .yearAndMonthOfFirstRegistration
                          )
                        }
                      />
                      <ErrorMessage
                        touched={
                          chatInputFormik.touched
                            .yearAndMonthOfFirstRegistration
                        }
                        error={
                          chatInputFormik.errors.yearAndMonthOfFirstRegistration
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        型式<span className={styles.required}>必須</span>
                      </p>
                      <TextField
                        fullWidth
                        type='text'
                        variant='outlined'
                        {...chatInputFormik.getFieldProps('carModel')}
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(event) =>
                          chatInputFormik.setFieldValue(
                            'carModel',
                            event.target.value
                          )
                        }
                        value={chatInputFormik.values.carModel || ''}
                        error={
                          !!(
                            chatInputFormik.touched.carModel &&
                            chatInputFormik.errors.carModel
                          )
                        }
                      />
                      <ErrorMessage
                        touched={chatInputFormik.touched.carModel}
                        error={chatInputFormik.errors.carModel}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        変更後の契約自動車登録番号
                        <span className={styles.required}>必須</span>
                      </p>
                      <TextField
                        fullWidth
                        type='text'
                        variant='outlined'
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        {...chatInputFormik.getFieldProps(
                          'updatedContractCarRegistrationNumber'
                        )}
                        onChange={(event) => {
                          chatInputFormik.setFieldValue(
                            'updatedContractCarRegistrationNumber',
                            event.target.value
                          );
                        }}
                        value={
                          chatInputFormik.values
                            .updatedContractCarRegistrationNumber || ''
                        }
                        error={
                          !!(
                            chatInputFormik.touched
                              .updatedContractCarRegistrationNumber &&
                            chatInputFormik.errors
                              .updatedContractCarRegistrationNumber
                          )
                        }
                      />
                      <ErrorMessage
                        touched={
                          chatInputFormik.touched
                            .updatedContractCarRegistrationNumber
                        }
                        error={
                          chatInputFormik.errors
                            .updatedContractCarRegistrationNumber
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        車台番号<span className={styles.required}>必須</span>
                      </p>
                      <TextField
                        fullWidth
                        type='text'
                        variant='outlined'
                        {...chatInputFormik.getFieldProps('chassisNumber')}
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(event) =>
                          chatInputFormik.setFieldValue(
                            'chassisNumber',
                            event.target.value
                          )
                        }
                        value={chatInputFormik.values.chassisNumber || ''}
                        error={
                          !!(
                            chatInputFormik.touched.chassisNumber &&
                            chatInputFormik.errors.chassisNumber
                          )
                        }
                      />
                      <ErrorMessage
                        touched={chatInputFormik.touched.chassisNumber}
                        error={chatInputFormik.errors.chassisNumber}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>用途車種</p>
                  <TextField
                    fullWidth
                    type='text'
                    variant='outlined'
                    {...chatInputFormik.getFieldProps('carType')}
                    disabled={!isPermitted(currentUser, detailData.lockedBy)}
                    onChange={(event) =>
                      chatInputFormik.setFieldValue(
                        'carType',
                        event.target.value
                      )
                    }
                    value={chatInputFormik.values.carType || ''}
                    error={
                      !!(
                        chatInputFormik.touched.carType &&
                        chatInputFormik.errors.carType
                      )
                    }
                  />
                  <ErrorMessage
                    touched={chatInputFormik.touched.carType}
                    error={chatInputFormik.errors.carType}
                  />
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>使用の本拠地</p>
                  <TextField
                    fullWidth
                    type='text'
                    variant='outlined'
                    {...chatInputFormik.getFieldProps('baseLocationForUse')}
                    disabled={!isPermitted(currentUser, detailData.lockedBy)}
                    onChange={(event) =>
                      chatInputFormik.setFieldValue(
                        'baseLocationForUse',
                        event.target.value
                      )
                    }
                    value={chatInputFormik.values.baseLocationForUse || ''}
                    error={
                      !!(
                        chatInputFormik.touched.baseLocationForUse &&
                        chatInputFormik.errors.baseLocationForUse
                      )
                    }
                  />
                  <ErrorMessage
                    touched={chatInputFormik.touched.baseLocationForUse}
                    error={chatInputFormik.errors.baseLocationForUse}
                  />
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>車両所有者（漢字）</p>
                  <TextField
                    fullWidth
                    type='text'
                    variant='outlined'
                    {...chatInputFormik.getFieldProps('carOwner')}
                    disabled={!isPermitted(currentUser, detailData.lockedBy)}
                    onChange={(event) =>
                      chatInputFormik.setFieldValue(
                        'carOwner',
                        event.target.value
                      )
                    }
                    value={chatInputFormik.values.carOwner || ''}
                    error={
                      !!(
                        chatInputFormik.touched.carOwner &&
                        chatInputFormik.errors.carOwner
                      )
                    }
                  />
                  <ErrorMessage
                    touched={chatInputFormik.touched.carOwner}
                    error={chatInputFormik.errors.carOwner}
                  />
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>車両所有者（カナ）</p>
                  <TextField
                    fullWidth
                    type='text'
                    variant='outlined'
                    {...chatInputFormik.getFieldProps('carOwnerKana')}
                    disabled={!isPermitted(currentUser, detailData.lockedBy)}
                    onChange={(event) =>
                      chatInputFormik.setFieldValue(
                        'carOwnerKana',
                        event.target.value
                      )
                    }
                    value={chatInputFormik.values.carOwnerKana || ''}
                    error={
                      !!(
                        chatInputFormik.touched.carOwnerKana &&
                        chatInputFormik.errors.carOwnerKana
                      )
                    }
                  />
                  <ErrorMessage
                    touched={chatInputFormik.touched.carOwnerKana}
                    error={chatInputFormik.errors.carOwnerKana}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>
                    変更後の車両保険金額
                    {(chatInputFormik.values.carInsuranceType === 1 ||
                      chatInputFormik.values.carInsuranceType === 2) && (
                        <span className={styles.required}>必須</span>
                      )}
                  </p>
                  <PriceCommaTextField
                    variant='outlined'
                    className={styles.moneyTextField}
                    value={chatInputFormik.values.updatedCarInsuranceFee}
                    maxDigit={9}
                    disabled={!isPermitted(currentUser, detailData.lockedBy)}
                    onChange={(_event, value) => {
                      chatInputFormik.setFieldValue(
                        'updatedCarInsuranceFee',
                        value
                      );
                    }}
                    onBlur={() => {
                      chatInputFormik.setFieldTouched(
                        'updatedCarInsuranceFee',
                        true
                      );
                    }}
                    error={
                      !!(
                        chatInputFormik.touched.updatedCarInsuranceFee &&
                        chatInputFormik.errors.updatedCarInsuranceFee
                      )
                    }
                  />
                  <span className={styles.centerText}>万円</span>
                  <ErrorMessage
                    touched={chatInputFormik.touched.updatedCarInsuranceFee}
                    error={chatInputFormik.errors.updatedCarInsuranceFee}
                  />
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>
                    自己負担額
                    {(chatInputFormik.values.carInsuranceType === 1 ||
                      chatInputFormik.values.carInsuranceType === 2) && (
                        <span className={styles.required}>必須</span>
                      )}
                  </p>
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      <PriceCommaTextField
                        fullWidth
                        variant='outlined'
                        maxDigit={9}
                        value={chatInputFormik.values.outOfPocketFeeFirstTime}
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(_event, value) => {
                          chatInputFormik.setFieldValue(
                            'outOfPocketFeeFirstTime',
                            value
                          );
                        }}
                        onBlur={() => {
                          chatInputFormik.setFieldTouched(
                            'outOfPocketFeeFirstTime',
                            true
                          );
                        }}
                        error={
                          !!(
                            chatInputFormik.touched.outOfPocketFeeFirstTime &&
                            chatInputFormik.errors.outOfPocketFeeFirstTime
                          )
                        }
                      />
                      <ErrorMessage
                        touched={
                          chatInputFormik.touched.outOfPocketFeeFirstTime
                        }
                        error={chatInputFormik.errors.outOfPocketFeeFirstTime}
                      />
                    </Grid>
                    <Grid item xs={1}>
                      <span className={styles.centerText}> - </span>
                    </Grid>
                    <Grid item xs={4}>
                      <PriceCommaTextField
                        fullWidth
                        variant='outlined'
                        maxDigit={9}
                        value={
                          chatInputFormik.values.outOfPocketFeeAfterSecondTime
                        }
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(_event, value) =>
                          chatInputFormik.setFieldValue(
                            'outOfPocketFeeAfterSecondTime',
                            value
                          )
                        }
                        onBlur={() => {
                          chatInputFormik.setFieldTouched(
                            'outOfPocketFeeAfterSecondTime',
                            true
                          );
                        }}
                        error={
                          !!(
                            chatInputFormik.touched
                              .outOfPocketFeeAfterSecondTime &&
                            chatInputFormik.errors.outOfPocketFeeAfterSecondTime
                          )
                        }
                      />
                      <ErrorMessage
                        touched={
                          chatInputFormik.touched.outOfPocketFeeAfterSecondTime
                        }
                        error={
                          chatInputFormik.errors.outOfPocketFeeAfterSecondTime
                        }
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <span className={styles.centerText}>万円</span>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>（長期）次年度車両保険金額</p>
                  <PriceCommaTextField
                    variant='outlined'
                    className={styles.moneyTextField}
                    maxDigit={9}
                    value={chatInputFormik.values.carInsuranceFeeNextYear}
                    disabled={!isPermitted(currentUser, detailData.lockedBy)}
                    onChange={(_event, value) => {
                      chatInputFormik.setFieldValue(
                        'carInsuranceFeeNextYear',
                        value
                      );
                    }}
                    onBlur={() => {
                      chatInputFormik.setFieldTouched(
                        'carInsuranceFeeNextYear',
                        true
                      );
                    }}
                    error={
                      !!(
                        chatInputFormik.touched.carInsuranceFeeNextYear &&
                        chatInputFormik.errors.carInsuranceFeeNextYear
                      )
                    }
                  />
                  <span className={styles.centerText}>万円</span>
                  <ErrorMessage
                    touched={chatInputFormik.touched.carInsuranceFeeNextYear}
                    error={chatInputFormik.errors.carInsuranceFeeNextYear}
                  />
                </div>
              </Grid>
              <Grid item xs={3}>
                <div>
                  <p className={styles.labelTop}>
                    （長期）３年度目車両保険金額
                  </p>
                  <PriceCommaTextField
                    variant='outlined'
                    className={styles.moneyTextField}
                    value={chatInputFormik.values.carInsuranceFeeThirdYear}
                    maxDigit={9}
                    disabled={!isPermitted(currentUser, detailData.lockedBy)}
                    onChange={(_event, value) => {
                      chatInputFormik.setFieldValue(
                        'carInsuranceFeeThirdYear',
                        value
                      );
                    }}
                    onBlur={() => {
                      chatInputFormik.setFieldTouched(
                        'carInsuranceFeeThirdYear',
                        true
                      );
                    }}
                    error={
                      !!(
                        chatInputFormik.touched.carInsuranceFeeThirdYear &&
                        chatInputFormik.errors.carInsuranceFeeThirdYear
                      )
                    }
                  />
                  <span className={styles.centerText}>万円</span>
                  <ErrorMessage
                    touched={chatInputFormik.touched.carInsuranceFeeThirdYear}
                    error={chatInputFormik.errors.carInsuranceFeeThirdYear}
                  />
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
      {detailData.nenrei?.id && (
        <Card className={clsx(classes.root, className)}>
          <CardHeader
            title='年齢条件・運転者限定'
            className={styles.lineChatColor}
          />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={7}>
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        個人・法人・保険始期選択
                        <span className={styles.required}>必須</span>
                      </p>
                      <Select
                        fullWidth
                        className={styles.selecter}
                        {...chatInputFormik.getFieldProps(
                          'isPersonalAndInsuranceStartTerm'
                        )}
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(event) => {
                          chatInputFormik.setFieldValue(
                            'isPersonalAndInsuranceStartTerm',
                            event.target.value || null
                          );
                        }}
                        value={chatInputFormik.values.isPersonalAndInsuranceStartTerm || 0}
                        error={
                          !!(
                            chatInputFormik.touched
                              .isPersonalAndInsuranceStartTerm &&
                            chatInputFormik.errors
                              .isPersonalAndInsuranceStartTerm
                          )
                        }
                      >
                        <MenuItem value={0}>&nbsp;</MenuItem>
                        <MenuItem value={1}>
                          {INDIVIDUAL_OR_CORPORATE[1]}
                        </MenuItem>
                        <MenuItem value={2}>
                          {INDIVIDUAL_OR_CORPORATE[2]}
                        </MenuItem>
                        <MenuItem value={3}>
                          {INDIVIDUAL_OR_CORPORATE[3]}
                        </MenuItem>
                      </Select>
                      <ErrorMessage
                        touched={
                          chatInputFormik.touched
                            .isPersonalAndInsuranceStartTerm
                        }
                        error={
                          chatInputFormik.errors.isPersonalAndInsuranceStartTerm
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        変更後の運転者限定条件
                        <span className={styles.required}>必須</span>
                      </p>
                      <Select
                        fullWidth
                        className={styles.selecter}
                        {...chatInputFormik.getFieldProps(
                          'updatedDriverSpecialContract'
                        )}
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(event) => {
                          chatInputFormik.setFieldValue(
                            'updatedDriverSpecialContract',
                            event.target.value || null
                          );
                        }}
                        value={chatInputFormik.values.updatedDriverSpecialContract || 0}
                        error={
                          !!(
                            chatInputFormik.touched
                              .updatedDriverSpecialContract &&
                            chatInputFormik.errors.updatedDriverSpecialContract
                          )
                        }
                      >
                        <MenuItem value={0}>&nbsp;</MenuItem>
                        <MenuItem value={1}>
                          {DRIVER_LIMITED_CONDITION[1]}
                        </MenuItem>
                        <MenuItem value={2}>
                          {DRIVER_LIMITED_CONDITION[2]}
                        </MenuItem>
                        <MenuItem value={3}>
                          {DRIVER_LIMITED_CONDITION[3]}
                        </MenuItem>
                        <MenuItem value={4}>
                          {DRIVER_LIMITED_CONDITION[4]}
                        </MenuItem>
                      </Select>
                      <ErrorMessage
                        touched={
                          chatInputFormik.touched.updatedDriverSpecialContract
                        }
                        error={
                          chatInputFormik.errors.updatedDriverSpecialContract
                        }
                      />
                    </div>
                  </Grid>
                  <Grid item xs={4}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        変更後の年齢条件
                        <span className={styles.required}>必須</span>
                      </p>
                      <Select
                        fullWidth
                        className={styles.selecter}
                        {...chatInputFormik.getFieldProps(
                          'updatedDriverAgeConditionSpecialContract'
                        )}
                        disabled={!isPermitted(currentUser, detailData.lockedBy)}
                        onChange={(event) => {
                          chatInputFormik.setFieldValue(
                            'updatedDriverAgeConditionSpecialContract',
                            event.target.value || null
                          );
                        }}
                        value={chatInputFormik.values.updatedDriverAgeConditionSpecialContract || 0}
                        error={
                          !!(
                            chatInputFormik.touched
                              .updatedDriverAgeConditionSpecialContract &&
                            chatInputFormik.errors
                              .updatedDriverAgeConditionSpecialContract
                          )
                        }
                      >
                        <MenuItem value={0}>&nbsp;</MenuItem>
                        <MenuItem value={1}>{DRIVER_AGE_CONDITION[1]}</MenuItem>
                        <MenuItem value={2}>{DRIVER_AGE_CONDITION[2]}</MenuItem>
                        <MenuItem value={3}>{DRIVER_AGE_CONDITION[3]}</MenuItem>
                        <MenuItem value={4}>{DRIVER_AGE_CONDITION[4]}</MenuItem>
                      </Select>
                      <ErrorMessage
                        touched={
                          chatInputFormik.touched
                            .updatedDriverAgeConditionSpecialContract
                        }
                        error={
                          chatInputFormik.errors
                            .updatedDriverAgeConditionSpecialContract
                        }
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        変更後の最若年運転者の性別
                      </p>
                      <p className={styles.text}>
                        {chatInput?.genderOfYoungest
                          ? GENDER[chatInput.genderOfYoungest]
                          : '-'}
                      </p>
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div className={styles.item}>
                      <p className={styles.labelTop}>
                        変更後の最若年運転者の免許証の色
                      </p>
                      <p className={styles.text}>
                        {chatInput?.driverLicenseColorOfYoungest
                          ? DRIVER_LICENSE_COLOR[
                          chatInput.driverLicenseColorOfYoungest
                          ]
                          : '-'}
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
      {detailData.purpose?.id && (
        <Card className={clsx(classes.root, className)}>
          <CardHeader title='使用目的変更' className={styles.lineChatColor} />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>変更後の使用目的</p>
                  <p className={styles.text}>
                    {chatInput?.afterCurrentPurpose
                      ? AFTER_CURRENT_PURPOSE[chatInput.afterCurrentPurpose]
                      : '-'}
                  </p>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className={styles.item}>
                  <p className={styles.labelTop}>業務専用車</p>
                  <p className={styles.text}>
                    {chatInput?.forBusinessUseCar
                      ? APPLICABLE_CHECK[chatInput.forBusinessUseCar]
                      : '-'}
                  </p>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
      <Card className={clsx(classes.root, className)}>
        <CardHeader title='共通（保険料）' className={styles.lineChatColor} />
        <Divider />
        <div className={styles.planTitle}>プラン①</div>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>
                  追加・返戻<span className={styles.required}>必須</span>
                </p>
                <Select
                  fullWidth
                  className={styles.selecter}
                  {...chatInputFormik.getFieldProps('addOrMinus')}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(event) => {
                    chatInputFormik.setFieldValue(
                      'addOrMinus',
                      event.target.value || null
                    );
                  }}
                  value={chatInputFormik.values.addOrMinus || 0}
                  error={
                    !!(
                      chatInputFormik.touched.addOrMinus &&
                      chatInputFormik.errors.addOrMinus
                    )
                  }
                >
                  <MenuItem value={0}>&nbsp;</MenuItem>
                  <MenuItem value={1}>{PLUS_MINUS[1]}</MenuItem>
                  <MenuItem value={2}>{PLUS_MINUS[2]}</MenuItem>
                </Select>
                <ErrorMessage
                  touched={chatInputFormik.touched.addOrMinus}
                  error={chatInputFormik.errors.addOrMinus}
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>
                  変更保険料
                  <span className={styles.required}>必須</span>
                </p>
                <PriceCommaTextField
                  variant='outlined'
                  className={styles.moneyTextField}
                  value={chatInputFormik.values.updatedInsuranceFee}
                  maxDigit={9}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(_event, value) => {
                    chatInputFormik.setFieldValue('updatedInsuranceFee', value);
                  }}
                  onBlur={() => {
                    chatInputFormik.setFieldTouched(
                      'updatedInsuranceFee',
                      true
                    );
                  }}
                  error={
                    !!(
                      chatInputFormik.touched.updatedInsuranceFee &&
                      chatInputFormik.errors.updatedInsuranceFee
                    )
                  }
                />
                <span className={styles.centerText}>円</span>
                <ErrorMessage
                  touched={chatInputFormik.touched.updatedInsuranceFee}
                  error={chatInputFormik.errors.updatedInsuranceFee}
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>変更後月払保険料</p>
                <PriceCommaTextField
                  variant='outlined'
                  className={styles.moneyTextField}
                  value={chatInputFormik.values.updatedMonthlyInsuranceFee}
                  maxDigit={9}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(_event, value) => {
                    chatInputFormik.setFieldValue(
                      'updatedMonthlyInsuranceFee',
                      value
                    );
                  }}
                  onBlur={() => {
                    chatInputFormik.setFieldTouched(
                      'updatedMonthlyInsuranceFee',
                      true
                    );
                  }}
                  error={
                    !!(
                      chatInputFormik.touched.updatedMonthlyInsuranceFee &&
                      chatInputFormik.errors.updatedMonthlyInsuranceFee
                    )
                  }
                />
                <span className={styles.centerText}>円</span>
                <ErrorMessage
                  touched={chatInputFormik.touched.updatedMonthlyInsuranceFee}
                  error={chatInputFormik.errors.updatedMonthlyInsuranceFee}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>（長期）次年度変更後保険料</p>
                <Grid container spacing={1}>
                  <Grid item xs={7}>
                    <PriceCommaTextField
                      fullWidth
                      variant='outlined'
                      value={
                        chatInputFormik.values.updatedInsuranceFeeOfNextYear
                      }
                      maxDigit={9}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(_event, value) => {
                        chatInputFormik.setFieldValue(
                          'updatedInsuranceFeeOfNextYear',
                          value
                        );
                      }}
                      onBlur={() => {
                        chatInputFormik.setFieldTouched(
                          'updatedInsuranceFeeOfNextYear',
                          true
                        );
                      }}
                      error={
                        !!(
                          chatInputFormik.touched
                            .updatedInsuranceFeeOfNextYear &&
                          chatInputFormik.errors.updatedInsuranceFeeOfNextYear
                        )
                      }
                    />
                    <ErrorMessage
                      touched={
                        chatInputFormik.touched.updatedInsuranceFeeOfNextYear
                      }
                      error={
                        chatInputFormik.errors.updatedInsuranceFeeOfNextYear
                      }
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <span className={styles.yen}>円/</span>
                    <Select
                      className={styles.selecter}
                      {...chatInputFormik.getFieldProps(
                        'paymentMethodOfNextYear'
                      )}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(event) => {
                        chatInputFormik.setFieldValue(
                          'paymentMethodOfNextYear',
                          event.target.value || null
                        );
                      }}
                      value={chatInputFormik.values.paymentMethodOfNextYear || 0}
                      error={
                        !!(
                          chatInputFormik.touched.paymentMethodOfNextYear &&
                          chatInputFormik.errors.paymentMethodOfNextYear
                        )
                      }
                    >
                      <MenuItem value={0}>&nbsp;</MenuItem>
                      <MenuItem value={1}>{PERIOD_UNIT[1]}</MenuItem>
                      <MenuItem value={2}>{PERIOD_UNIT[2]}</MenuItem>
                    </Select>
                    <ErrorMessage
                      touched={chatInputFormik.touched.paymentMethodOfNextYear}
                      error={chatInputFormik.errors.paymentMethodOfNextYear}
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>（長期）３年度目変更後保険料</p>
                <Grid container spacing={1}>
                  <Grid item xs={7}>
                    <PriceCommaTextField
                      fullWidth
                      variant='outlined'
                      value={
                        chatInputFormik.values.updatedInsuranceFeeOfThirdYear
                      }
                      maxDigit={9}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(_event, value) => {
                        chatInputFormik.setFieldValue(
                          'updatedInsuranceFeeOfThirdYear',
                          value
                        );
                      }}
                      onBlur={() => {
                        chatInputFormik.setFieldTouched(
                          'updatedInsuranceFeeOfThirdYear',
                          true
                        );
                      }}
                      error={
                        !!(
                          chatInputFormik.touched
                            .updatedInsuranceFeeOfThirdYear &&
                          chatInputFormik.errors.updatedInsuranceFeeOfThirdYear
                        )
                      }
                    />
                    <ErrorMessage
                      touched={
                        chatInputFormik.touched.updatedInsuranceFeeOfThirdYear
                      }
                      error={
                        chatInputFormik.errors.updatedInsuranceFeeOfThirdYear
                      }
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <span className={styles.yen}>円/</span>
                    <Select
                      className={styles.selecter}
                      {...chatInputFormik.getFieldProps(
                        'paymentMethodOfThirdYear'
                      )}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(event) => {
                        chatInputFormik.setFieldValue(
                          'paymentMethodOfThirdYear',
                          event.target.value || null
                        );
                      }}
                      value={chatInputFormik.values.paymentMethodOfThirdYear || 0}
                      error={
                        !!(
                          chatInputFormik.touched.paymentMethodOfThirdYear &&
                          chatInputFormik.errors.paymentMethodOfThirdYear
                        )
                      }
                    >
                      <MenuItem value={0}>&nbsp;</MenuItem>
                      <MenuItem value={1}>{PERIOD_UNIT[1]}</MenuItem>
                      <MenuItem value={2}>{PERIOD_UNIT[2]}</MenuItem>
                    </Select>
                    <ErrorMessage
                      touched={chatInputFormik.touched.paymentMethodOfThirdYear}
                      error={chatInputFormik.errors.paymentMethodOfThirdYear}
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </CardContent>
        <div className={styles.planTitle}>プラン② 〜 新価特約</div>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}> 追加・返戻</p>
                <Select
                  fullWidth
                  className={styles.selecter}
                  {...chatInputFormik.getFieldProps(
                    'newCarSpecialContractAddOrMinus'
                  )}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(event) => {
                    chatInputFormik.setFieldValue(
                      'newCarSpecialContractAddOrMinus',
                      event.target.value || null
                    );
                  }}
                  value={chatInputFormik.values.newCarSpecialContractAddOrMinus || 0}
                  error={
                    !!(
                      chatInputFormik.touched.newCarSpecialContractAddOrMinus &&
                      chatInputFormik.errors.newCarSpecialContractAddOrMinus
                    )
                  }
                >
                  <MenuItem value={0}>&nbsp;</MenuItem>
                  <MenuItem value={1}>{PLUS_MINUS[1]}</MenuItem>
                  <MenuItem value={2}>{PLUS_MINUS[2]}</MenuItem>
                </Select>
                <ErrorMessage
                  touched={
                    chatInputFormik.touched.newCarSpecialContractAddOrMinus
                  }
                  error={chatInputFormik.errors.newCarSpecialContractAddOrMinus}
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}>変更保険料</p>
                <PriceCommaTextField
                  variant='outlined'
                  className={styles.moneyTextField}
                  value={
                    chatInputFormik.values
                      .newCarSpecialContractUpdatedInsuranceFee
                  }
                  maxDigit={9}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(_event, value) =>
                    chatInputFormik.setFieldValue(
                      'newCarSpecialContractUpdatedInsuranceFee',
                      value
                    )
                  }
                  onBlur={() => {
                    chatInputFormik.setFieldTouched(
                      'newCarSpecialContractUpdatedInsuranceFee',
                      true
                    );
                  }}
                  error={
                    !!(
                      chatInputFormik.touched
                        .newCarSpecialContractUpdatedInsuranceFee &&
                      chatInputFormik.errors
                        .newCarSpecialContractUpdatedInsuranceFee
                    )
                  }
                />
                <span className={styles.centerText}>円</span>
                <ErrorMessage
                  touched={
                    chatInputFormik.touched
                      .newCarSpecialContractUpdatedInsuranceFee
                  }
                  error={
                    chatInputFormik.errors
                      .newCarSpecialContractUpdatedInsuranceFee
                  }
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}> 変更後月払保険料</p>
                <PriceCommaTextField
                  variant='outlined'
                  className={styles.moneyTextField}
                  value={
                    chatInputFormik.values
                      .newCarSpecialContractUpdatedMonthlyInsuranceFee
                  }
                  maxDigit={9}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(_event, value) =>
                    chatInputFormik.setFieldValue(
                      'newCarSpecialContractUpdatedMonthlyInsuranceFee',
                      value
                    )
                  }
                  onBlur={() => {
                    chatInputFormik.setFieldTouched(
                      'newCarSpecialContractUpdatedMonthlyInsuranceFee',
                      true
                    );
                  }}
                  error={
                    !!(
                      chatInputFormik.touched
                        .newCarSpecialContractUpdatedMonthlyInsuranceFee &&
                      chatInputFormik.errors
                        .newCarSpecialContractUpdatedMonthlyInsuranceFee
                    )
                  }
                />
                <span className={styles.centerText}>円</span>
                <ErrorMessage
                  touched={
                    chatInputFormik.touched
                      .newCarSpecialContractUpdatedMonthlyInsuranceFee
                  }
                  error={
                    chatInputFormik.errors
                      .newCarSpecialContractUpdatedMonthlyInsuranceFee
                  }
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}> （長期）次年度変更後保険料</p>
                <Grid container spacing={1}>
                  <Grid item xs={7}>
                    <PriceCommaTextField
                      fullWidth
                      variant='outlined'
                      value={
                        chatInputFormik.values
                          .newCarSpecialContractUpdatedInsuranceFeeOfNextYear
                      }
                      maxDigit={9}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(_event, value) =>
                        chatInputFormik.setFieldValue(
                          'newCarSpecialContractUpdatedInsuranceFeeOfNextYear',
                          value
                        )
                      }
                      onBlur={() => {
                        chatInputFormik.setFieldTouched(
                          'newCarSpecialContractUpdatedInsuranceFeeOfNextYear',
                          true
                        );
                      }}
                      error={
                        !!(
                          chatInputFormik.touched
                            .newCarSpecialContractUpdatedInsuranceFeeOfNextYear &&
                          chatInputFormik.errors
                            .newCarSpecialContractUpdatedInsuranceFeeOfNextYear
                        )
                      }
                    />
                    <ErrorMessage
                      touched={
                        chatInputFormik.touched
                          .newCarSpecialContractUpdatedInsuranceFeeOfNextYear
                      }
                      error={
                        chatInputFormik.errors
                          .newCarSpecialContractUpdatedInsuranceFeeOfNextYear
                      }
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <span className={styles.yen}>円/</span>
                    <Select
                      className={styles.selecter}
                      {...chatInputFormik.getFieldProps(
                        'newCarSpecialContractPaymentMethodOfNextYear'
                      )}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(event) => {
                        chatInputFormik.setFieldValue(
                          'newCarSpecialContractPaymentMethodOfNextYear',
                          event.target.value || null
                        );
                      }}
                      value={chatInputFormik.values.newCarSpecialContractPaymentMethodOfNextYear || 0}
                      error={
                        !!(
                          chatInputFormik.touched
                            .newCarSpecialContractPaymentMethodOfNextYear &&
                          chatInputFormik.errors
                            .newCarSpecialContractPaymentMethodOfNextYear
                        )
                      }
                    >
                      <MenuItem value={0}>&nbsp;</MenuItem>
                      <MenuItem value={1}>{PERIOD_UNIT[1]}</MenuItem>
                      <MenuItem value={2}>{PERIOD_UNIT[2]}</MenuItem>
                    </Select>
                    <ErrorMessage
                      touched={
                        chatInputFormik.touched
                          .newCarSpecialContractPaymentMethodOfNextYear
                      }
                      error={
                        chatInputFormik.errors
                          .newCarSpecialContractPaymentMethodOfNextYear
                      }
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={styles.item}>
                <p className={styles.labelTop}> （長期）３年度目変更後保険料</p>
                <Grid container spacing={1}>
                  <Grid item xs={7}>
                    <PriceCommaTextField
                      fullWidth
                      variant='outlined'
                      value={
                        chatInputFormik.values
                          .newCarSpecialContractUpdatedInsuranceFeeOfThirdYear
                      }
                      maxDigit={9}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(_event, value) =>
                        chatInputFormik.setFieldValue(
                          'newCarSpecialContractUpdatedInsuranceFeeOfThirdYear',
                          value
                        )
                      }
                      onBlur={() => {
                        chatInputFormik.setFieldTouched(
                          'newCarSpecialContractUpdatedInsuranceFeeOfThirdYear',
                          true
                        );
                      }}
                      error={
                        !!(
                          chatInputFormik.touched
                            .newCarSpecialContractUpdatedInsuranceFeeOfThirdYear &&
                          chatInputFormik.errors
                            .newCarSpecialContractUpdatedInsuranceFeeOfThirdYear
                        )
                      }
                    />
                    <ErrorMessage
                      touched={
                        chatInputFormik.touched
                          .newCarSpecialContractUpdatedInsuranceFeeOfThirdYear
                      }
                      error={
                        chatInputFormik.errors
                          .newCarSpecialContractUpdatedInsuranceFeeOfThirdYear
                      }
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <span className={styles.yen}>円/</span>
                    <Select
                      className={styles.selecter}
                      {...chatInputFormik.getFieldProps(
                        'newCarSpecialContractPaymentMethodOfThirdYear'
                      )}
                      disabled={!isPermitted(currentUser, detailData.lockedBy)}
                      onChange={(event) => {
                        chatInputFormik.setFieldValue(
                          'newCarSpecialContractPaymentMethodOfThirdYear',
                          event.target.value || null
                        );
                      }}
                      value={chatInputFormik.values.newCarSpecialContractPaymentMethodOfThirdYear || 0}
                      error={
                        !!(
                          chatInputFormik.touched
                            .newCarSpecialContractPaymentMethodOfThirdYear &&
                          chatInputFormik.errors
                            .newCarSpecialContractPaymentMethodOfThirdYear
                        )
                      }
                    >
                      <MenuItem value={0}>&nbsp;</MenuItem>
                      <MenuItem value={1}>{PERIOD_UNIT[1]}</MenuItem>
                      <MenuItem value={2}>{PERIOD_UNIT[2]}</MenuItem>
                    </Select>
                    <ErrorMessage
                      touched={
                        chatInputFormik.touched
                          .newCarSpecialContractPaymentMethodOfThirdYear
                      }
                      error={
                        chatInputFormik.errors
                          .newCarSpecialContractPaymentMethodOfThirdYear
                      }
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <p className={styles.labelTop}>
                変更後保険料について
                <span className={styles.required}>必須</span>
              </p>
              <Select
                fullWidth
                className={styles.selecter}
                {...chatInputFormik.getFieldProps('aboutUpdatedInsuranceFee')}
                disabled={!isPermitted(currentUser, detailData.lockedBy)}
                onChange={(event) => {
                  chatInputFormik.setFieldValue(
                    'aboutUpdatedInsuranceFee',
                    event.target.value | null
                  );
                  chatInputFormik.setFieldValue(
                    'aboutUpdatedInsuranceFeeDetail',
                    PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE_TEXT[
                    event.target.value
                    ]
                  );
                }}
                value={chatInputFormik.values.aboutUpdatedInsuranceFee || 0}
                error={
                  !!(
                    chatInputFormik.touched.aboutUpdatedInsuranceFee &&
                    chatInputFormik.errors.aboutUpdatedInsuranceFee
                  )
                }
              >
                <MenuItem value={0}>&nbsp;</MenuItem>
                <MenuItem value={1}>
                  {PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE[1]}
                </MenuItem>
                <MenuItem value={2}>
                  {PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE[2]}
                </MenuItem>
                <MenuItem value={3}>
                  {PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE[3]}
                </MenuItem>
                <MenuItem value={4}>
                  {PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE[4]}
                </MenuItem>
                <MenuItem value={5}>
                  {PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE[5]}
                </MenuItem>
                <MenuItem value={6}>
                  {PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE[6]}
                </MenuItem>
                <MenuItem value={7}>
                  {PAYMENT_METHOD_OF_UPDATED_INSURANCE_FEE[7]}
                </MenuItem>
              </Select>
              <ErrorMessage
                touched={chatInputFormik.touched.aboutUpdatedInsuranceFee}
                error={chatInputFormik.errors.aboutUpdatedInsuranceFee}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type='text'
                variant='outlined'
                {...chatInputFormik.getFieldProps(
                  'aboutUpdatedInsuranceFeeDetail'
                )}
                disabled={!isPermitted(currentUser, detailData.lockedBy)}
                onChange={(event) =>
                  chatInputFormik.setFieldValue(
                    'aboutUpdatedInsuranceFeeDetail',
                    event.target.value
                  )
                }
                value={chatInputFormik.values.aboutUpdatedInsuranceFeeDetail || ''}
                error={
                  !!(
                    chatInputFormik.touched.aboutUpdatedInsuranceFeeDetail &&
                    chatInputFormik.errors.aboutUpdatedInsuranceFeeDetail
                  )
                }
              />
              <ErrorMessage
                touched={chatInputFormik.touched.aboutUpdatedInsuranceFeeDetail}
                error={chatInputFormik.errors.aboutUpdatedInsuranceFeeDetail}
              />
            </Grid>
            <Grid item xs={12}>
              <div className={styles.item}>
                <p className={styles.labelTop}>
                  カスタマーセンターからのご連絡事項
                </p>
                <TextField
                  fullWidth
                  type='text'
                  variant='outlined'
                  multiline
                  rows={3}
                  {...chatInputFormik.getFieldProps('remarks')}
                  disabled={!isPermitted(currentUser, detailData.lockedBy)}
                  onChange={(event) =>
                    chatInputFormik.setFieldValue('remarks', event.target.value)
                  }
                  value={chatInputFormik.values.remarks || ''}
                  error={
                    !!(
                      chatInputFormik.touched.remarks &&
                      chatInputFormik.errors.remarks
                    )
                  }
                />
                <ErrorMessage
                  touched={chatInputFormik.touched.remarks}
                  error={chatInputFormik.errors.remarks}
                />
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default ChatInputEdit;
